import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  TextField,
  FormControl,
  InputLabel,
  ToggleButtonGroup,
  ToggleButton,
  Select,
  Menu,
  MenuItem,
  Button,
  Zoom,
  Typography,
  List,
  ListItemButton,
  Tooltip,
  TablePagination,
  Tabs,
  Tab,
} from "@mui/material";
import SouthIcon from "@mui/icons-material/South";
import MainPage from "../_layout/main.page";
import emptyfolder from "../assets/images/empty-folder.png";
import pdffile from "../assets/images/pdf-file.svg";
import PdfThumbnail from "../components/pdfthumbnail";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import nofolder from "../assets/images/folder.png";
import nofile from "../assets/images/no_gen_file.png";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import CloseIcon from "@mui/icons-material/Close";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import LibraryReactPdf from "../components/pdf_view/library-react-pdf";
import host from "../host";
import nogenfile from "../assets/images/no_gen_file.png";
import { useDispatch } from "react-redux";
import { changeAuth } from "../actions/loginAction";
import MessageSnackbar from "../_layout/elements/snackbar";
import ListIcon from "@mui/icons-material/List";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import { useNavigate } from "react-router-dom";
import PdfList from "../components/pdflist";
import UploadType from "../components/upload-type";
import MarkUnreadChatAltOutlinedIcon from "@mui/icons-material/MarkUnreadChatAltOutlined";
import TableLoader from "../components/loader/table-loader";
import SearchLoader from "../components/loader/search_loader";
import AddIcon from "@mui/icons-material/Add";
import AddBrain from "../components/add-brain";
import HeaderPage from "../_layout/elements/header";
import FolderActions from "../components/folder-actions";
import HistoryLoader from "../components/loader/history-loader";
export const Uploadknowledge = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //brain - list functionality begins
  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const onClose = () => {
    setSnackbar(false);
  };

  const [alignment, setAlignment] = React.useState("grid");
  const handleAlignment = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  const [brainList, setBrainList] = useState([]);
  const [selectedBrain, setSelectedbrain] = useState(null);

  //add brain
  const [openaddbrain, setOpendeleteaddbrain] = React.useState(false);
  const activeaddbrain = () => setOpendeleteaddbrain(true);
  const handleCloseaddbrain = () => {
    setOpendeleteaddbrain(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [folderList, setFolderList] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const getbrains = () => {
    setIsLoaded(false);
    fetch(host.chaturl + `/brain`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setIsLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          setBrainList(data);
          setIsLoaded(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoaded(true);
      });
  };

  

  useEffect(() => {
    if (brainList.length > 0) {
      const tempList = brainList.filter((brain) => {
        if (value === 0) {
          return brain;
        } else if ((value === 2 && brain.status === "public") || (value === 1 && brain.status === "private")) {
          return brain;
        }
      });
      setFolderList(tempList);
    } else {
      setFolderList([]);
    }
  }, [brainList, value]);

  useEffect(() => {
    if (brainList.length > 0) {
      setSelectedbrain(brainList[0]);
    }
  }, [brainList]);


  useEffect(() => {
    if (brainList?.length > 0) {
      setSelectedFolder(brainList[0] ? brainList[0] : null);
      getSelectedKnowledge(brainList[0].id ? brainList[0].id : null);
    }
  }, [brainList]);

  //brain - list functionality ends
  //upload document implementaion starts
  // const [searchByFile, setSearchByFile] = useState("");
  const [searchByBrain, setSearchByBrain] = useState(null);
  const [pdfListLoading, setPdfListLoading] = useState(false);
  const [pdfListData, setPdfListData] = useState([]);
  const [selectedPDFs, setSelectedPDFs] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState();
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [totalCount, setTotalCount] = useState();

  const handleSelectBrain = (folder) => {
    setSelectedFolder(folder);
    getSelectedKnowledge(folder.id);
    return;
  };

  const handleChatAllDoc = () => {
    // const pdfIdListData = pdfListData.map((item) => item.id);
    //navigate(`/home?knowledge=[${pdfIdListData.join(",")}]`);
    getDocChatId([]);
  };

  const handleChatSelectedDoc = () => {
    const selectedIdPDFs = selectedPDFs.map((item) => item.id);
    getDocChatId(selectedIdPDFs);
    // navigate(`/home?knowledge=[${pdfIdListData.join(",")}]`);
  };

  const handleChatSpecificDoc = (pdf) => {
    getDocChatId([pdf.id]);
  };

  const getDocChatId = (docList) => {
    //Yet to be implemented if it came from handleChatAllDoc, array is empty and dont add it to the body. if handleChatSelectedDoc, send the array as parameter

    let payload = {
      chat_name: "Untitled",
      knowledges: docList,
    };

    if (docList.length === 0) {
      payload = {
        chat_name: "Untitled",
      };
    }

    fetch(host.chaturl + "/chat/knowledges", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(payload),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          localStorage.clear();
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else if (res.status === 400) {
          setSeverity("error");
          setMessage("Your folder has no valid file for chat. Please upload a valid file to proceed");
          setSnackbar(true);
        } else {
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          navigate(`/knowledgeChat/${data.chat_id}`);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getKnowledge = () => {
    setPdfListLoading(true);
    let mainQuery = `${host.chaturl}/knowledge?page=${page + 1}&limit=${limit}`;
    // if (searchByFile !== "") {
    //   mainQuery += `&file_name=${searchByFile}`;
    // }

    if (searchByBrain !== null) {
      mainQuery += `&brain_id=${searchByBrain.id}`;
    }
    fetch(mainQuery, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setPdfListLoading(false);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          setPdfListData(data.knowledge_documents);
          setTotalCount(data.total_count);
          setPdfListLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setPdfListLoading(false);
      });
  };

  const getSelectedKnowledge = async (folder_id) => {
    setPdfListLoading(true);
    let mainQuery = `${host.chaturl}/knowledge/${folder_id}`;
    // if (searchByFile !== "") {
    //   mainQuery += `&file_name=${searchByFile}`;
    // }

    if (searchByBrain !== null) {
      mainQuery += `&brain_id=${searchByBrain.id}`;
    }
    await fetch(mainQuery, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setPdfListLoading(false);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          setPdfListData(data);
          setTotalCount(data.total_count ? data.total_count : 0);
          setPdfListLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setPdfListLoading(false);
      });
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      //setPage(1);
      Promise.all([getKnowledge()])
        .then(() => {})
        .catch((_error) => {});
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchByBrain, page, limit]);

  const [searchByContext, setSearchByContext] = useState("");
  const [searchContextResult, setSearchContextResult] = useState(null);
  const [filteredResults, setFilteredResults] = useState([]);
  const [searchContextLoading, setSearchContextLoading] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  const [sortFilter, setSortFilter] = useState(urlParams.has("sortBy") ? urlParams.get("sortBy") : "created_at");
  const [statusFilter, setStatusFilter] = useState(urlParams.has("status") ? urlParams.get("status") : "all");
  const [dateFilter, setDateFilter] = useState(urlParams.has("date") ? urlParams.get("date") : "any_date");

  const getFilteredBrains = () => {
    setIsLoaded(false);
    fetch(host.chaturl + `/brain/filter?sort_by=${sortFilter}&page=1&limit=100`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setIsLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          setBrainList(data.brains);
          setIsLoaded(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoaded(true);
      });
  }

  useEffect(() => {
    // getbrains();
    if(sortFilter){
      getFilteredBrains();
    }
  }, [sortFilter]);

  useEffect(() => {
    if (searchByContext !== "") {
      const urlParameters = new URLSearchParams(window.location.search);

      urlParameters.set("status", statusFilter);
      navigate({
        pathname: "/uploadknowledge",
        search: urlParameters.toString(),
      });
    }
  }, [statusFilter]);

  useEffect(() => {
    if (searchByContext !== "") {
      const urlParameters = new URLSearchParams(window.location.search);

      urlParameters.set("date", dateFilter);
      navigate({
        pathname: "/uploadknowledge",
        search: urlParameters.toString(),
      });
    }
  }, [dateFilter]);

  useEffect(() => {
    const urlParameters = new URLSearchParams(window.location.search);

    urlParameters.set("sortBy", sortFilter);
    navigate({
      pathname: "/uploadknowledge",
      search: urlParameters.toString(),
    });
  }, [sortFilter]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleStatusFilterChange = (event) => {
    setStatusFilter(event.target.value);
  };

  const handleDateFilterChange = (value) => {
    setDateFilter(value);
    handleClose();
  };

  const getSearchResult = () => {
    setSearchContextLoading(true);
    let mainQuery = `${host.chaturl}/knowledge/search?search_query=${searchByContext}&sort_by=${sortFilter}`;
    fetch(mainQuery, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setSearchContextLoading(false);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          setSearchContextResult(data.knowledges);
          setSearchContextLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setSearchContextLoading(false);
      });
  };

  useEffect(() => {
    if (searchByContext !== "") {
      const delayDebounceFn = setTimeout(() => {
        Promise.all([getSearchResult()])
          .then(() => {})
          .catch((_error) => {});
      }, 2000);
      return () => clearTimeout(delayDebounceFn);
    }
  }, [searchByContext]);

  const isDateInRange = (dateString, dateFilter) => {
    const itemDate = new Date(dateString);
    const currentDate = new Date();

    // Calculate the start date based on the date filter
    let startDate;
    switch (dateFilter) {
      case "last_24_hours":
        startDate = new Date(currentDate.getTime() - 24 * 60 * 60 * 1000);
        break;
      case "last_week":
        startDate = new Date(currentDate.getTime() - 7 * 24 * 60 * 60 * 1000);
        break;
      case "last_month":
        startDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, currentDate.getDate());
        break;
      case "last_year":
        startDate = new Date(currentDate.getFullYear() - 1, currentDate.getMonth(), currentDate.getDate());
        break;
      default:
        return true;
    }

    // Check if the item's date is within the selected range
    return itemDate >= startDate && itemDate <= currentDate;
  };

  const filterResults = () => {
    if (searchContextResult.length === 0) return;

    const filtered = searchContextResult.filter((item) => {
      if ((statusFilter !== "all" && item.status !== statusFilter) || (dateFilter !== "any_date" && !isDateInRange(item.created_at, dateFilter))) {
        return false;
      }
      return true;
    });
    setFilteredResults(filtered);
  };

  useEffect(() => {
    if (searchContextResult && searchContextResult.length > 0) {
      filterResults();
    }
  }, [statusFilter, dateFilter, searchContextResult]);

  //upload document implementaion ends

  //library pdf implementation starts
  const [activePdf, setActivePdf] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const toggleDrawer = (file_path, file_name) => {
    setActivePdf({ file_path, file_name });
    setIsOpen(true);
  };
  const closeDrawer = () => {
    setIsOpen(false);
  };

  const [viewerKey, setViewerKey] = useState(0); // reset the viewer key to re-render the docviewer
  const [docs, setDocs] = useState([]); // set the docs to be rendered in the docviewer
  const [isPdfSelected, setIsPdfSelected] = useState(false); // relevant for DocViewer

  useEffect(() => {
    setViewerKey((prevKey) => prevKey + 1);
  }, [docs]);

  useEffect(() => {
    if (activePdf) {
      const fileName = activePdf?.file_name;
      const fileParts = fileName.split(".");
      const fileExtension = fileParts[fileParts.length - 1];
      setIsPdfSelected(fileExtension === "pdf");
      if (fileExtension !== "pdf") {
        setDocs([{ uri: activePdf?.file_path, fileType: fileExtension, fileName: activePdf?.file_name }]);
      }
    }
  }, [activePdf]);

  //library pdf implementation ends
  return (
    <>
      <MainPage>
        <HeaderPage />
        <MessageSnackbar open={snackbar} autoHideDuration={3000} onClose={onClose} severity={severity} message={message} />

        <div className="page-content">
          <div className="container">
            <div className="row justify-content-center">
              <div className="library_wrapper">
                <div className={`library_flex_box ${isOpen ? "open" : ""}`}>
                  <div className="library_Left_section">
                    <div className="library_top_head">
                      <div className="card_head_title">
                        <h3>My Library</h3>
                        {/*<p>Chat with your uploaded documents</p>*/}

                        {/* 
                           <LibraryBreadcrumb/>
                           */}
                      </div>
                      <div className="library_tabs">
                        <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons="auto" aria-label="scrollable auto tabs example">
                          <Tab label="All" />
                          <Tab label="Private" />
                          <Tab label="Public" />
                        </Tabs>
                      </div>
                      {/*<div className="card_action">
                        <div className="uploadtype">
                          {brainList.length > 0 ? (
                            <UploadType brainList={brainList} getKnowledge={getKnowledge} />
                          ) : (
                            <button type="button" className="btn btn-default" onClick={activeaddbrain}>
                              <AddIcon fontSize="small" />
                              Add Brain
                            </button>
                          )}
                        </div>
                        {searchByContext === "" && (
                          <div className="change_list_view">
                            <ToggleButtonGroup size="small" value={alignment} exclusive onChange={handleAlignment} aria-label="text alignment">
                              <ToggleButton value="list" aria-label="left aligned">
                                <ListIcon fontSize="small" />
                              </ToggleButton>
                              <ToggleButton value="grid" aria-label="centered">
                                <GridViewOutlinedIcon fontSize="small" />
                              </ToggleButton>
                            </ToggleButtonGroup>
                          </div>
                        )}
                      </div>*/}
                      <div className="card_action">
                        <div className="uploadtype">
                          {brainList.length > 0 ? (
                            <UploadType
                              brainList={brainList}
                              setBrainList={setBrainList}
                              selectedBrain={selectedBrain}
                              setSelectedbrain={setSelectedbrain}
                              getKnowledge={getKnowledge}
                              getbrains={getbrains}
                            />
                          ) : (pdfListLoading &&
                            <button type="button" className="btn btn-default" onClick={activeaddbrain}>
                              <AddIcon fontSize="small" />
                              Create Folder
                            </button>
                          )}
                        </div>
                        <div className="change_list_view">
                          <ToggleButtonGroup size="small" value={alignment} exclusive onChange={handleAlignment} aria-label="text alignment">
                            <ToggleButton value="list" aria-label="left aligned">
                              <ListIcon fontSize="small" />
                            </ToggleButton>
                            <ToggleButton value="grid" aria-label="centered">
                              <GridViewOutlinedIcon fontSize="small" />
                            </ToggleButton>
                          </ToggleButtonGroup>
                        </div>
                        {/* <div className="storage">
                          <Tooltip className="blue-tooltip" title="Files Storage" TransitionComponent={Zoom} placement="top" arrow>
                            <IconButton className="bg-inverse-gray" aria-label="add to shopping cart">
                              <StorageOutlinedIcon />
                            </IconButton>
                          </Tooltip>
                        </div> */}
                      </div>
                    </div>
                    <div className="library-sections">
                      <div className=" upload-pdflist">
                        <div className="candidate-table-action">
                          <div className="candidate-table-action-row">
                            <div className="table_action_cta search_library_inputbox">
                              <TextField
                                id="outlined-multiline-flexible"
                                placeholder="Search by file name, folder name or content"
                                value={searchByContext}
                                disabled={searchContextLoading}
                                onChange={(e) => {
                                  setSearchByContext(e.target.value);
                                }}
                              />
                              <div className="search-icon">
                                {searchByContext !== "" ? (
                                  <Link to="" onClick={() => setSearchByContext("")}>
                                    <Tooltip className="blue-tooltip" title="Clear search" TransitionComponent={Zoom} placement="top" arrow>
                                      <CloseIcon
                                        style={{
                                          fontSize: "22px",
                                          color: "#919EAB",
                                        }}
                                      />
                                    </Tooltip>
                                  </Link>
                                ) : (
                                  <SearchOutlinedIcon />
                                )}
                              </div>
                              {/* <FormControl fullWidth size="small">
                                <TextField
                                  size="small"
                                  id="outlined-multiline-flexible"
                                  label="Search Files"
                                  value={searchByFile}
                                  onChange={(e) => {
                                    setSearchByFile(e.target.value);
                                  }}
                                />
                              </FormControl> */}
                            </div>
                            {/* {brainList && brainList.length > 0 && (
                              <div className="table_action_cta">
                                <FormControl fullWidth size="small">
                                  <InputLabel id="demo-simple-select-label">Search by brain name</InputLabel>
                                  <Select
                                    key={searchByBrain ? searchByBrain.id : brainList[0].id}
                                    labelId="demo-select-small-label"
                                    id="demo-select-small"
                                    value={searchByBrain ? searchByBrain.id : brainList[0].id}
                                  >
                                    <MenuItem value={0}>Select Brain</MenuItem>
                                    {brainList.map((brain,index) => {
                                      return (
                                        <MenuItem
                                          value={brain.id}
                                          key={index+1}
                                          onClick={() => {
                                            setSearchByBrain(brain);
                                          }}
                                        >
                                          {brain.name ? brain.name : "NA"}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </FormControl>
                              </div>
                            )} */}

                            <div className="table_action_cta">
                              <div className="table_action_btn">
                                <button type="button" className="btn btn-primary " onClick={handleChatAllDoc} disabled={brainList.length > 0 ? false : true}>
                                  <MarkUnreadChatAltOutlinedIcon fontSize="small" /> Chat With All Files
                                </button>
                                <button type="button" className="btn btn-default " onClick={handleChatSelectedDoc} disabled={selectedPDFs.length > 0 ? false : true}>
                                  <MarkUnreadChatAltOutlinedIcon fontSize="small" />{" "}
                                  {alignment === "grid" ? "Chat with selected Files (Ctrl + Click for selecting multiple file)" : "Chat with selected Files"}
                                </button>
                              </div>
                            </div>
                            {searchByContext === "" && (
                              <div className=" table_action_cta library_search_action">
                                <div className="sort_files">
                                  <div className="search_filter_cta ">
                                    {folderList && folderList.length > 0 && (
                                      <Tooltip title="Sort by">
                                        <Button onClick={handleClick} variant="outlined" startIcon={<FilterListOutlinedIcon />}>
                                          <div className="sortlabel">
                                            <span> Sort :</span>
                                            <div className="sortvalue">
                                              {sortFilter === "name" ? "Name" : sortFilter === "created_at" ? "Date Created" : "File Size"}
                                              <SouthIcon style={{ fontSize: "16px" }} />
                                            </div>
                                          </div>
                                        </Button>
                                      </Tooltip>
                                    )}
                                    <Menu
                                      anchorEl={anchorEl}
                                      id="account-menu"
                                      open={open}
                                      onClose={handleClose}
                                      onClick={handleClose}
                                      PaperProps={{
                                        elevation: 0,
                                        sx: {
                                          overflow: "visible",
                                          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                                          mt: 1.5,
                                          "& .MuiAvatar-root": {
                                            width: 32,
                                            height: 32,
                                            ml: -0.5,
                                            mr: 1,
                                          },
                                          "&::before": {
                                            content: '""',
                                            display: "block",
                                            position: "absolute",
                                            top: 0,
                                            right: 14,
                                            width: 10,
                                            height: 10,
                                            bgcolor: "background.paper",
                                            transform: "translateY(-50%) rotate(45deg)",
                                            zIndex: 0,
                                          },
                                        },
                                      }}
                                      transformOrigin={{ horizontal: "right", vertical: "top" }}
                                      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                                    >
                                      <MenuItem
                                        onClick={() => {
                                          setSortFilter("name");
                                          handleClose();
                                        }}
                                      >
                                        Sort By Name
                                      </MenuItem>

                                      <MenuItem
                                        onClick={() => {
                                          setSortFilter("created_at");
                                          handleClose();
                                        }}
                                      >
                                        Date Created
                                      </MenuItem>

                                      <MenuItem
                                        onClick={() => {
                                          setSortFilter("file_size");
                                          handleClose();
                                        }}
                                      >
                                        File Size
                                      </MenuItem>
                                    </Menu>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        {searchByContext !== "" ? (
                          <div className="library_search_section" id="librarysearch">
                            <div className="library_search_wrapper ">
                              <div className="library_search_head  ">
                                <div className="sources_title">
                                  <h5>Search Results</h5>
                                </div>
                                <div className="search_filter">
                                  <div className="search_filter_row">
                                    <div className="search_filter_cta action_half">
                                      <FormControl fullWidth size="small">
                                        <InputLabel id="demo-simple-select-label">Upload Status</InputLabel>
                                        <Select labelId="demo-select-small-label" id="demo-select-small" value={statusFilter} onChange={handleStatusFilterChange}>
                                          <MenuItem value="all">All</MenuItem>
                                          <MenuItem value="completed">Processed</MenuItem>
                                          <MenuItem value="processing">In Progress</MenuItem>
                                        </Select>
                                      </FormControl>
                                    </div>
                                    {/* <div className="search_filter_cta action_half">
                                  <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={people}
                                    size="small"
                                    renderInput={(params) => (
                                      <TextField {...params} label="People" />
                                    )}
                                  />
                                </div> */}
                                    <div className="search_filter_cta ">
                                      <Tooltip title="Sort by">
                                        <Button onClick={handleClick} variant="outlined" startIcon={<FilterListOutlinedIcon />}>
                                          Sort By
                                        </Button>
                                      </Tooltip>
                                      <Menu anchorEl={anchorEl} id="account-menu" open={open} onClose={handleClose}>
                                        <MenuItem selected={dateFilter === "any_date"} onClick={() => handleDateFilterChange("any_date")}>
                                          Any Date
                                        </MenuItem>
                                        <MenuItem selected={dateFilter === "last_24_hours"} onClick={() => handleDateFilterChange("last_24_hours")}>
                                          Last 24 hours
                                        </MenuItem>
                                        <MenuItem selected={dateFilter === "last_week"} onClick={() => handleDateFilterChange("last_week")}>
                                          Last week
                                        </MenuItem>
                                        <MenuItem selected={dateFilter === "last_month"} onClick={() => handleDateFilterChange("last_month")}>
                                          Last month
                                        </MenuItem>
                                        <MenuItem selected={dateFilter === "last_year"} onClick={() => handleDateFilterChange("last_year")}>
                                          Last year
                                        </MenuItem>
                                      </Menu>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {searchContextLoading ? (
                                <div className="skeleton_loader">
                                  <SearchLoader />
                                </div>
                              ) : filteredResults && filteredResults.length > 0 ? (
                                <div className="library_search_body">
                                  <List className="">
                                    {filteredResults.map((item, index) => (
                                      <ListItemButton key={index} alignItems="center" className="mb-3" onClick={() => toggleDrawer(item.file_path, item.file_name)}>
                                        <div className="pdficonlibrary">
                                          <img src={pdffile} alt="" />
                                        </div>
                                        <div className="pdf_search_content">
                                          <h5>{item.file_name}</h5>
                                          {item.chunk !== "" ? (
                                            <Typography
                                              dangerouslySetInnerHTML={{
                                                __html: item.chunk.replace(/<b>/g, "<mark>").replace(/<\/b>/g, "</mark>"),
                                              }}
                                            />
                                          ) : (
                                            ""
                                          )}
                                          <div className="search_file_detail">
                                            <div className="search_file_row">
                                              <span>Uploaded By </span>
                                              <span>-</span>
                                              <span>{item.user ? item.user.fullname : "NA"}</span>
                                            </div>
                                            <div className="search_devider">/</div>
                                            <div className="search_file_row">
                                              <span>
                                                {new Date(item.created_at).toLocaleDateString("en-US", {
                                                  year: "numeric",
                                                  month: "short",
                                                  day: "numeric",
                                                })}
                                              </span>
                                            </div>
                                            <div className="search_devider">/</div>
                                            <div className="search_file_row">
                                              <span className={`d-flex gap-2 align-items-center`}>
                                                <span className={`circle ${item.status === "completed" ? "bg-success" : "bg-warning"}`}></span>
                                                {item.status === "completed" ? "Processed" : "Processing"}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </ListItemButton>
                                    ))}
                                  </List>
                                </div>
                              ) : (
                                <div className="no_content-wrapper ">
                                  <div className="no-content-box">
                                    <div className="no_content-icon">
                                      <img src={emptyfolder} alt="" height={100} />
                                    </div>
                                    <div className="no_content-title">No results found</div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        ) : (
                          <>
                            {
                              
                            
                              <>
                              <div className='switch_wrapper'>
                              <div className='switch_flex'>

                              {folderList && folderList.length > 0 &&<>
                              <div className='folder_aside'>
                              <div className='folder_box'>
                              <div className="library_search_head  ">
                                            <div className="sources_title">
                                              <h5>Folders </h5>
                                            </div>
                                          </div>
                                          {isLoaded ? (                                           
                                              <>
                                                <div className="pdf_folder_flex">
                                                  {folderList.map((folder, index) => {
                                                    return (
                                                      <div className="pdf_folder_cta" key={index}>
                                                        <Link to="" className={selectedFolder ? (selectedFolder.id === folder.id ? "active" : "") : ""}>
                                                          <div className="d-flex align-items-center   ">
                                                            <div
                                                              className="file-row"
                                                              onClick={() => handleSelectBrain(folder)}
                                                              // onKeyDown={(
                                                              //   event
                                                              // ) => {
                                                              //   if (
                                                              //     event.key ===
                                                              //     "Enter"
                                                              //   ) {
                                                              //      event.preventDefault();
                                                              //      navigate(`/brain-setting/${folder.id}`);
                                                              //   }
                                                              // }}
                                                            >
                                                              {/* <img src={folder} height={30} alt=''/> */}
                                                              <FolderOutlinedIcon />
                                                              <div className="filerowname">{folder.name ? folder.name : "NA"}</div>
                                                            </div>
                                                            <div className="pdf_actions">
                                                              <FolderActions brain={folder} getBrains={getbrains} setSnackbar={setSnackbar} setSeverity={setSeverity} setMessage={setMessage} />
                                                            </div>
                                                          </div>
                                                        </Link>
                                                      </div>
                                                    );
                                                  })}
                                                </div>
                                              </>
                                            
                                          ) : (
                                            <HistoryLoader />
                                          )}
                                </div>
                                </div>
                              
                                <div className='switch_content'>
                                <div className='switch_content_box'>
                                 {pdfListLoading === false && pdfListData && pdfListData.length > 0 && <>
                                    {alignment === "list" && (
                                      <>
                                        <div className="pdf_table_wrapper">
                                          
                                          <div className="library_search_head pt-4 ">
                                            <div className="sources_title">
                                              <h5>Files</h5>
                                            </div>
                                          </div>
                                          <div className='pdf_thumbnail_row'>
                                          <PdfList
                                            page={page}
                                            setPage={setPage}
                                            limit={limit}
                                            setLimit={setLimit}
                                            totalCount={totalCount}
                                            setTotalCount={setTotalCount}
                                            selectedPDFs={selectedPDFs}
                                            setSelectedPDFs={setSelectedPDFs}
                                            pdfListData={pdfListData}
                                            setPdfListData={setPdfListData}
                                            handleChatSpecificDoc={handleChatSpecificDoc}
                                            getKnowledge={getKnowledge}
                                          />
                                          </div>
                                          
                                        </div>
                                      </>
                                    )}
                                    {alignment === "grid" && (
                                      <div className="pdf_thumbnail_wrapper">                                        
                                        <div className="pdf_thumbnail_row">
                                          <div className="library_search_head  ">
                                            <div className="sources_title">
                                              <h5>Files</h5>
                                            </div>
                                          </div>
                                          <div className='switch_content_body'>
                                          <div className="pdf_thumbnail_flex">
                                            <PdfThumbnail
                                              page={page}
                                              setPage={setPage}
                                              limit={limit}
                                              setLimit={setLimit}
                                              totalCount={totalCount}
                                              setTotalCount={setTotalCount}
                                              selectedPDFs={selectedPDFs}
                                              setSelectedPDFs={setSelectedPDFs}
                                              pdfListData={pdfListData}
                                              setPdfListData={setPdfListData}
                                              handleChatSpecificDoc={handleChatSpecificDoc}
                                              getKnowledge={getKnowledge}
                                              toggleDrawer={toggleDrawer}
                                            />
                                          </div>
                                          </div>
                                         
                                          <div className="mt-4 table-pagination">
                                            <TablePagination
                                              rowsPerPageOptions={[5, 10, 25, 100]}
                                              component="div"
                                              rowsPerPage={limit}
                                              page={page}
                                              onPageChange={handleChangePage}
                                              onRowsPerPageChange={handleChangeRowsPerPage}
                                              count={totalCount}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    )}                                   
                                    
                                  </>}
                                    {pdfListLoading && <div className="skeleton_loader">
                                <TableLoader />
                              </div>}
                                 {pdfListLoading === false && pdfListData && pdfListData.length === 0 && <>
                                    <div className="library_search_head pt-4 ">
                                      <div className="sources_title">{folderList && folderList.length > 0 && <h5>Files </h5>}</div>
                                    </div>
                                    <div className="no_content-wrapper">
                                      {folderList && folderList.length > 0 && (
                                        <div className="no-content-box">
                                          <div className="no_content-icon">
                                            <img src={nofile} alt="" height={100} />
                                          </div>
                                          <div className="no_content-title">Empty folder, no documents uploaded </div>
                                          <div className="no_content-pera">
                                            <span> Add files to your folder by clicking on the 'Upload File/Folder' button in the top right corner and get started </span>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    </>}
                                 </div>
                                </div>
                              </>}                            


                                
                              </div>
                            </div>
                            {folderList && folderList.length === 0 && <div className="no_content-wrapper " style={{ display: "block" }}>
                                                <div className="no-content-box">
                                                  <div className="no_content-icon">
                                                    <img src={nogenfile} alt="" height={100} />
                                                  </div>
                                                  <div className="no_content-title">
                                                    {" "}
                                                    No Folders Found{" "}
                                                  </div>
                                                  <div className="no_content-pera">
                                                    <span>Create your folder by clicking on the 'Create Folder' button in the top right corner and get started </span>
                                                  </div>
                                                </div>
                                              </div>}
                                
                              </>
                            }
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <AddBrain
                    brainList={brainList}
                    setBrainList={setBrainList}
                    openaddbrain={openaddbrain}
                    handleCloseaddbrain={handleCloseaddbrain}
                    getbrains={getbrains}
                    getKnowledge={getKnowledge}
                    selectedBrain={selectedBrain}
                    setSelectedbrain={setSelectedbrain}
                  />
                  <div className="library_open_pdf">
                    {activePdf?.file_path && activePdf?.file_name && (
                      <LibraryReactPdf file_path={activePdf.file_path} file_name={activePdf.file_name} activePdf={activePdf} closeDrawer={closeDrawer} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MainPage>
    </>
  );
};
